import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import _ from "lodash";
import { Form, Formik, FormikValues } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  EC_SUBMISSION_TYPES,
  RoutingList,
  stepsInfo,
} from "../../../../constants";
import { useCreateEcsMutation } from "../../../../generated/graphql";
import useAppStore from "../../../../states/zustand/appStore";
import { formikMultiStepHandler } from "../../../../utils/formikMultiStepFormStepHandler";
import { logger } from "../../../../utils/logger";
import CreatePageFormFooter from "../../../common/Form/CreatePageFormFooter/CreatePageFormFooter";
import ProgressSteps from "../../../common/ProgressSteps/ProgressSteps";
import ECSubmissionIR from "../ECSubmission/ECSubmissionIR";
import StudyDetails from "../StudyDetails/StudyDetails";
import { InitialReviewInitData, IRBSubmissionValidationSchema } from "../utils";
import { DocumentSubmissionDropdown } from "../../../../types/forms/DoumentSubmission";

type IRProps = {
  value: any;
};

const InitialReview = (props: IRProps) => {
  const { value } = props;
  const [currentStep, setCurrentStep] = useState(0);
  const [createEcsMutation] = useCreateEcsMutation();
  const navigate = useNavigate();
  const { setLoader } = useAppStore();

  const saveHandler = async (values: FormikValues) => {
    try {
      // const reqFields = values.documents
      //   .filter((doc: any) => doc.required === true)
      //   .map((doc: { url: string }) => doc.url !== "");
      //   console.log(reqFields)

      //    if (reqFields) {
      //      return;
      //    }

      setLoader(true);
      console.log('StudyReport_StudyReport')
      await createEcsMutation({
        variables: {
          department: values.department,
          emails: values.emails|| [],
          isFunded: values.isFunded|| false,
          fundType: values.fundType,
          micr: values.micr,
          principalInvestigator: values.principalInvestigator,
          coInvestigator: values.coInvestigator,
          protocolNumber: values.protocolNumber,
          sponsor: values.sponsor,
          studyPhase: values.studyPhase,
          title: values.title,
          typeOfStudy: values.typeOfStudy,
          documents: values.documents
            .filter((doc: DocumentSubmissionDropdown) => doc.url !== "")
            .map((doc: DocumentSubmissionDropdown ) => ({
              label: doc.dropdownSelectedValue ? doc.label + '(' + doc.dropdownSelectedValue + ')' : doc.label,
              url: doc.url,
              remark: doc.remark,
              // dropdownSelectedValue: doc.dropdownSelectedValue|| ''
            })),
          type: EC_SUBMISSION_TYPES.INITAL_REVIEW,
        },
      });
      toast.success("EC submission created successfully!");
      navigate(RoutingList.ethics_committee.index.path);
    } catch (err) {
      toast.error(
        (err as { message: string })?.message || "Something went wrong"
      );
      logger.error(err);
    } finally {
      setLoader(false);
    }
  };

  return (
    <Formik
      initialValues={_.cloneDeep(InitialReviewInitData)}
      validationSchema={IRBSubmissionValidationSchema[currentStep]}
      onSubmit={(values, { setSubmitting, setErrors, validateForm }) => {
        const documents = [...values.documents].filter(
          (item) => item.url !== ""
        );
        formikMultiStepHandler({
          validateForm,
          values: { ...values, documents },
          stepIndex:
            currentStep > stepsInfo.length - 1 ? currentStep : currentStep + 1,
          setErrors,
          steps: currentStep,
          stepsInfo,
          setSteps: setCurrentStep,
          saveHandler,
        });
      }}
    >
      <Form>
        <Card>
          <CardContent className="pd-x-30 pd-y-30">
            <Box className="mg-b-40">
              <Typography className="mg-b-10" variant="h2" component="h2">
                Initial Review
              </Typography>
              <ProgressSteps stepsInfo={stepsInfo} currentStep={currentStep} />
            </Box>
            <Grid container className="justify-content-center">
              <Grid item xs={12} md={10} lg={10}>
                {currentStep === 0 && <StudyDetails value={value} />}
                {currentStep === 1 && <ECSubmissionIR />}
                <CreatePageFormFooter
                  setSteps={setCurrentStep}
                  steps={currentStep}
                  stepsInfo={stepsInfo}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Form>
    </Formik>
  );
};

export default InitialReview;
